<template lang="pug">
    div(v-if="data && Object.keys(data).length"
        class="stock-section-container"
        style="position:relative; padding-left: 12px; height:100%; border: 0px solid red;" ref="stocks")
        //- v-navigation-drawer(id="navigationDrawer" ref="drawer" absolute right :width="navigation.width" v-model="navigation.shown" :class="{'shadow-box': navigation.shown}" style="z-index:10000;")
            div(class="pa-3")

                div(v-show="target === 'research'" class="grey4 pl-4 pr-2" style="border: 2px solid green")

                    DrawerHeadlineButtons(:stockData="stockData" :highlightSelection="'research'" @childToggleEvent="childToggleEvent" @closeNavigation="closeNavigation")

                    div(style="border:0px solid;")
                        froala(v-if="(((user.type === 'new' || user.type === 'freemium' || user.type === 'visitor') && (researchTotalNumber <= 10 || researchs.find(item => item.stock_id === this.stock_id))) || user.subscription_id !== null || user.type === 'admin')" :tag="'textarea'" :config="froalaConfig" v-model="froalaContent" id="edit" style="width:30px;")

                    div(class="text-right mt-3" style="border:0px solid;")

                        div(v-if="saveStates === 'saving'" style="display:inline-block; border:0px solid;")
                            v-icon(size="25" class="rotate-icon mr-2" style="height:30px; margin-bottom:7px; border:0px solid;") mdi-sync
                            div(class="mr-2" style="font-size:17px; color:#636161; display:inline-block; border:0px solid;") Saving...

                        div(v-else-if="saveStates === 'saved'" style="display:inline-block; border:0px solid;")
                            v-icon(size="25" class="mr-2" style="height:30px; margin-bottom:7px; border:0px solid;") $saved
                            div(style="font-size:17px; color:#636161; display:inline-block; border:0px solid;") Saved
                            div(class="ml-2" style="display:inline-block; border:0px solid;")

                        div(style="display:inline-block; border:0px solid;")
                            v-btn(@click="saveNote()" class="blue3 white--text" :style="saveStates === '' ? 'margin-top:3.5px;' : ''" style="font-size:15px; height:30px;") {{ $t('save_notes') }}

                div(v-show="target === 'journal'" class="grey4 pl-4 pr-2" )
                    DrawerHeadlineButtons(:stockData="stockData" :highlightSelection="'journal'" @childToggleEvent="childToggleEvent" @closeNavigation="closeNavigation")
                    journal(ref="myJournalElement" @updateChart="updateChart" :stock_id="data.stock_id" style="overflow:hidden; height:calc(100vh - 142px); border-radius:5px; border:1px solid #A3B3C2;")

                div(v-show="target === 'estimate'")
                    DrawerHeadlineButtons(:stockData="stockData" :highlightSelection="'estimates'" @childToggleEvent="childToggleEvent" @closeNavigation="closeNavigation" class="pl-4 pr-2")
                    Estimates(:target="target")

                div(v-if="target === 'research' && paywallCriteria" style="position: absolute; z-index: 1000; width:100%; top:250px;")
                    div(class="pt-8 pb-8 pl-4 pr-4" style="background:#FDF5CA; width:75%; margin:auto; text-align:center; box-shadow: 12px 12px 20px 0 rgba(0, 0, 0, 0.3); border:1px solid;")
                        div This research will not be saved with your free plan.
                        div (10 document limit)
                        div(class="mt-4 mb-4") We want to build World class investment tools but we must also pay for the electricity... sign-up for a premium plan
                        PremiumButton
                        div(class="mt-4")
                            span and
                            span
                                b send us a message&nbsp;
                            span on how we can&nbsp;
                            span
                                b better serve you

        v-row(id="firstRowTitleMenu" no-gutters class="stock-section-header")

            div(class="latest-top-company")
                div(class="latest-company-title")
                    Ticker(
                        :stockId="stockData.stock_id"
                        :isClickable="false"
                    )
                    div(class="content-title") {{stockData.name}}
                div(id="secondRowTitleMenu"
                    no-gutters
                    class="latest-company-sector")
                    span() {{ $t(`${stockData.sector_name}`) }}

            div(class="latest-top-srch")
                WatchlistAddTo(:stocks="[stockData]" class="")

            div(class="latest-top-tags")
                div(v-if="isInWatchlist" class="latest-top-tags-container")
                    TagSelector(:stock="stockData"
                                :tagsString="tags"
                                from='stock'
                                class="latest-top-tags-selct")
                    div(class="latest-top-tags-conv")
                        Conviction(:value="rating_value" :stock="stockData" :dense="false")
                div(class="stocks-popup-btn")
                    v-btn(@click="openDrawer()" id="openDrawerElement" class="clr-pink" style="width:68px; height:68px")
                        v-icon() $iconDocumentEdit

                //- div(style="float:left; height:45px; padding-top:6px; border:0px solid;")
                    v-btn(@click="toggleEvent(false,'journal'), focusNewNoteTextField()" class="white--text" style="background-color:#2CB19C;" elevation="0" small) {{ $t('Journal') }}
                    v-btn(@click="toggleEvent(false,'research')" class="white--text ml-8" style="background-color:#2CB19C;" elevation="0" small) {{ $t('research') }}
                    v-btn(@click="toggleEvent(false,'estimate')" class="white--text ml-8" style="background-color:#2CB19C;" elevation="0" small) {{ $t('estimates') }}



        v-tabs(v-model="tab" align-with-title hide-slider class=""
               style="border: 0px solid orange; margin-top: 12px; background-color: transparent")

            v-tab(v-for="(item, index) in items" :key="item"
                class="stock-section m-0"
                @click="getTabInd(index)") {{ item }}

            v-tabs-items(v-model="tab" class="" style="border:0px solid orange;")
                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    StocksOverview( v-if="tab === 0 && reloadStockOverview" :company_id="company_id" :stock="data")

                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    StocksInvestorReports( v-if="tab === 1" :company_id="company_id" :stock_id="stock_id" :flag="flag" ref="stocksInvestorReports")

                v-tab-item(:transition="false" :reverse-transition="false")
                    ChartPrice( v-if="tab === 2" :company_id="company_id" :stock_id="stock_id" ref="chartPrice" page="main" style="height:780px;")

                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    CompanyNews( v-if="tab === 3" :company_id="company_id" :stock_id="stock_id" class="" style="max-width:65%;padding-right: 2px;")

                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    StocksFinancials( v-if="tab === 4" :company_id="company_id" :stock_id="stock_id")

                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    StocksInsiders( v-if="tab === 5" :company_id="company_id" :stock_id="stock_id")

                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    ImpactMetrics( v-if="tab === 6")

                v-tab-item(:transition="false" :reverse-transition="false" class="")
                    StockAnalysis( v-if="tab === 7" :company_id="company_id" :stock_id="stock_id" ref="stockAnalysis")

        //- Drawer for Research, Journal and Estimates option buttons
        v-dialog(v-model="dialog" persistent hide-overlay no-click-animation transition="dialog-top-transition" width="599" style="z-index:10000000;")
            v-card(id="navigationDrawer" height="785" style="border-radius:8px; border:0px solid; background-color:#f4f4f4;")
                div(class="" style="position:relative; border:0px solid;padding: 24px 12px 0 12px")

                    div(class="" style="display:flex;justify-content:space-between;position:relative")
                        div(style="display:inline-block")
                            Ticker(
                                :stockId="stockData.stock_id"
                                :isClickable="false"
                            )
                        div(style="font-size:12px;")
                            v-btn(@click="changeTab('research')" :class="(option === 'research') ? 'yellow2' : '-white'" class="black--text" elevation="0" v-ripple="false" style="width:100px; border-radius:4px 4px 0 0;") {{ $t('research') }}
                            v-btn(@click="changeTab('journal')" :class="(option === 'journal') ? 'yellow2' : '-white'" class="black--text" elevation="0" v-ripple="false" style="width:100px; border-radius:4px 4px 0 0;") {{ $t('Journal') }}
                            v-btn(@click="changeTab('estimates')" :class="(option === 'estimates') ? 'yellow2' : '-white'" class="black--text" elevation="0" v-ripple="false" style="width:100px; margin-right:40px; border-radius:4px 4px 0 0;") {{ $t('estimates') }}
                        div(style="position:absolute; right: 0; top:-12px")
                            v-icon(@click="closeDrawer()") mdi-close

                    div(style="height:715px; overflow-y:scroll; overflow-x:hidden; border:0px solid;")
                        div(v-if="option === 'research'" style="border:0px solid;")
                            div
                                froala(v-if="(((user.type === 'new' || user.type === 'freemium' || user.type === 'visitor') && (researchTotalNumber <= 10 || researchs.find((item) => item.stock_id === stock_id))) || user.subscription_id !== null || user.type === 'admin')" :tag="'textarea'" :config="froalaConfig" v-model="froalaContent" id="edit" style="width:30px;")
                            div(class="text-right mt-3" style="border:0px solid;")
                                div(v-if="saveStates === 'saving'" style="display:inline-block; border:0px solid;")
                                    v-icon(size="25" class="rotate-icon mr-2" style="height:30px; margin-bottom:7px; border:0px solid;") mdi-sync
                                    div(class="mr-2" style="font-size:17px; color:#636161; display:inline-block; border:0px solid;") Saving...
                                div(v-else-if="saveStates === 'saved'" style="display:inline-block; border:0px solid;")
                                    v-icon(size="25" class="mr-2" style="height:30px; margin-bottom:7px; border:0px solid;") $saved
                                    div(style="font-size:17px; color:#636161; display:inline-block; border:0px solid;") Saved
                                    div(class="ml-2" style="display:inline-block; border:0px solid;")
                                div(style="display:inline-block; border:0px solid;")
                                    v-btn(@click="saveNote()" class="btn-primary" :style="saveStates === '' ? '-margin-top:3.5px;' : ''" style="text-transform: capitalize") {{ $t('save_notes') }}

                        div(v-else-if="option === 'journal'" style="border:0px solid;")
                            journal(ref="myJournalElement" @updateChart="updateChart" :stock_id="data.stock_id" style="overflow:hidden; height:713px; border-radius:5px; -background-color:#fff")

                        div(v-else-if="option === 'estimates'" style="border:0px solid")
                            Estimates(:target="target")
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
/* eslint-disable no-console */
import ApiStocks from "@/Services/ApiStocks.js";
import ApiService from "@/Services/ApiService.js";
import StocksOverview from "@/views/stock/StocksOverview.vue";
import StocksInvestorReports from "@/views/stock/StocksInvestorReports.vue";
import PremiumButton from "@/components/PremiumButton.vue";
import VueFroala from "vue-froala-wysiwyg";
import ChartPrice from "@/components/ChartPrice.vue";
import StocksFinancials from "@/views/stock/StocksFinancials.vue";
import StocksInsiders from "@/views/stock/StocksInsiders.vue";
import ImpactMetrics from "@/views/stock/ImpactMetrics.vue";
import StockAnalysis from "@/views/stock/StockAnalysis.vue";
import TagSelector from "../watchlist/TagDropDown1.vue";
import Conviction from "../../components/Conviction.vue";
import Journal from '../../components/Journal';
import Estimates from '../../components/Estimates.vue';
import WatchlistAddTo from "@/components/WatchlistAddTo.vue";
import CompanyNews from './../news/CompanyNews.vue';
import Ticker from "../../components/Ticker.vue";
import DrawerHeadlineButtons from './DrawerHeadlineButtons.vue';
import ImpactMetricsVue from './ImpactMetrics.vue';

export default {
    components: {
        StocksOverview,
        PremiumButton,
        VueFroala,
        StocksInvestorReports,
        ChartPrice,
        StocksFinancials,
        StocksInsiders,
        ImpactMetrics,
        StockAnalysis,
        TagSelector,
        Conviction,
        Journal,
        Estimates,
        WatchlistAddTo,
        CompanyNews,
        Ticker,
        DrawerHeadlineButtons
    },
    props: {
    },
    data() {
        return {
            option: '',
            dialog: false,
            saveStates: '',
            estimatesRightContainerWidth: 565,
            toggleRight1: -36.5,
            toggleRight2: -43,
            topPositionResearch: 20.37,
            user: JSON.parse(localStorage.getItem('user')),
            tmp_data: {},
            target: '',
            is_show_tags_convictions: false,
            froalaConfig: {
                listAdvancedTypes: true,
                fontFamilyDefaultSelection: "Verdana",
                fontSizeDefaultSelection: "13",
                placeholderText: "My Research...    ",
                width: "100%",
                height: "536px",//"calc(100vh - 503px)",
                immediateVueModelUpdate: true,
                charCounterCount: false,
                documentReady: false,
                attribution: false,
                key: process.env.VUE_APP_FROALA_KEY,
                pluginsEnabled: [
                    "fontSize",
                    "colors",
                    "fontFamily",
                    "paragraphFormat",
                    "getPDF",
                    "align",
                    "lists",
                    "image",
                    "table",
                    "codeView",
                    "fullscreen",
                    "print",
                ],
                language: "sv",
                toolbarButtons: [
                    [
                        "H1",
                        "H2",
                    ],
                    [
                        "bold",
                        "italic",
                        "underline",
                        "highlight",
                    ],
                    [
                        "formatUL",
                        "formatOL",
                        "alignLeft",
                        "alignCenter",
                        "hr",
                        "insertImage",
                    ],
                    [
                        "undo",
                        "redo",
                        "fullscreen",
                    ],
                ],
                toolbarVisibleWithoutSelection: true,
                imageUpload: true,
                imageDefaultAlign: "center",
                imageDefaultDisplay: "inline-block",
                imageMaxSize: 5 * 1024 * 1024,
                imageAllowedTypes: ["jpeg", "jpg", "png"],
                imageUploadParam: "imageFile",
                imageUploadURL: `${process.env.VUE_APP_BACKEND_URL}/froala/image`,
                imageUploadMethod: "POST",
                events: {
                    // eslint-disable-next-line no-unused-vars
                    initialized: function (e, editor) {
                    },
                },
            },
            timer: null,
            newItem: 5,
            navigation: {
                shown: false,
                width: 200,
                borderSize: 10
            },
            watchlist: [],
            tab: 0,
            reloadStockOverview: true,
            froalaContent: '',
            default_froalaContent: '',
            flag: 0
        };
    },
    computed: {
        ...mapGetters([
            'getAllStocks',
            "getMapCompanies",
            "getCompanyWebcasts",
            "getCompanyAnalysts",
            "getMapStocks",
            "getAllCompanies",
            "getMapExchanges"
        ]),
        paywallCriteria() {
            return ((this.user.type === 'new' || this.user.type === 'freemium') && (this.researchTotalNumber > 10 && !this.$store.getters.getResearchs.find(item => item.stock_id === this.stock_id))) && this.user.subscription_id === null;
        },
        researchTotalNumber() {
            return this.$store.getters.getResearchs.length;
        },
        researchs() {
            return this.$store.getters.getResearchs;
        },
        data() {
            // console.log('data...');
            // console.log(JSON.parse(JSON.stringify(this.stockData)));

            let stock = JSON.parse(JSON.stringify(this.stockData));

            if (this.$route.query && this.$route.query.tab) {
                stock.tab = Number(this.$route.query.tab);
            }

            return stock;
        },
        stockData() {
            return this.getMapStocks.find(s => s.stock_id === this.stock_id);
        },
        stockInSector() {
            let stock_data = this.getMapStocks.find(s => s.stock_id == this.stock_id);
            let stocksInSector = [];
            this.getAllStocks.forEach(s => {
                if (s.sector_id === stock_data.sector_id) {
                    const c = this.getAllCompanies.get(s.company_id);
                    const sx = this.getMapExchanges.get(s.stock_exchange_id);
                    if (c) {
                        s.last_report_date = c.last_report_date;
                        s.market_cap = c.market_cap;
                        s.country = (sx) ? sx.country: '';
                        stocksInSector.push(s);
                    }
                }
            });
            return stocksInSector.find((sis) => sis.stock_id === this.stock_id);
        },
        tags() {
            return this.$store.getters["getWatchlistItems"].filter(item => item.stock_id === this.stock_id)[0].tags;
        },
        isInWatchlist() {
            return (this.$store.getters["getWatchlistItems"].filter(item => item.stock_id === this.stock_id).length > 0 ? true: false);
        },
        // eslint-disable-next-line vue/return-in-computed-property
        rating_value(){
            let is_conviction = (this.$store.getters["getWatchlistItems"].filter(item => item.stock_id === this.stock_id).length > 0 ? true: false);
            if (is_conviction)
                return (this.$store.getters["getWatchlistItems"].find(item => item.stock_id === this.stock_id).conviction);
        },
        items(){
            let stock = JSON.parse(JSON.stringify(this.stockData));
            let analysis_array = this.getCompanyAnalysts;

            let analysis_init = analysis_array.filter(item => item.company_id === stock.company_id);

            if (analysis_init.length > 0) {
                return [
                    this.$t('overview'),
                    this.$t('Investor_reports').toUpperCase(),
                    this.$t('Chart').toUpperCase(),
                    this.$t('news'),
                    this.$t('Financials').toUpperCase(),
                    this.$t('insider_trades'),
                    this.$t('alternative_data'),
                    this.$t('analyst')
                ];
            } else {
                return [
                    this.$t('overview'),
                    this.$t('Investor_reports').toUpperCase(),
                    this.$t('Chart').toUpperCase(),
                    this.$t('news'),
                    this.$t('Financials').toUpperCase(),
                    this.$t('insider_trades'),
                    this.$t('alternative_data')
                ];
            }
        },
        stock_id() {
            return parseInt(this.$route.params.stock_id);
        },
        company_id() {
            return this.getAllStocks.find((s) => s.stock_id === this.stock_id).company_id;
        },
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        }
    },
    watch: {
        option() {
            setTimeout(() => {
                let textAreaElement = '';

                if(this.option === 'research') {
                    // console.log('research...');
                    // console.log(document.getElementsByClassName('fr-element')[0]);

                    textAreaElement = document.getElementsByClassName('fr-element')[0];

                    textAreaElement.addEventListener('focus', this.focusOnFroalaTextArea);
                    textAreaElement.addEventListener('blur', this.blurOnFroalaTextArea);
                } else {
                    if(textAreaElement !== '') {
                        textAreaElement.removeEventListener('focus', this.focusOnFroalaTextArea);
                        textAreaElement.removeEventListener('blur', this.blurOnFroalaTextArea);
                    }
                }
            }, 100);
        },
        data() {
            this.tmp_data = JSON.parse(JSON.stringify(this.data));
            this.init();
        },
        newItem(val) {
            const that = this;
            const payload = {
                watchlist_id: this.watchlist[val].watchlist_id,
                user_id: JSON.parse(localStorage.getItem('user')).user_id,
                company_id: this.stockData.company_id,
                stock_id: this.stockData.stock_id,
                ticker: this.stockData.ticker,
                isin: this.stockData.isin,
                name: this.stockData.name,
                conviction: 0,
                watched_since: new Date().toISOString().substring(0, 10),
                watched_since_price: this.stockData.price_today,
            };

            // console.log(JSON.stringify(payload ));

            ApiStocks.insertWatchlistItem(payload).then((response) => {
                // console.log(JSON.stringify( response.data ));
                that.$store.commit("addWatchlistItem", response.data);
            });
        },
        froalaContent: function () {
            if(this.user_id === 0) {
                return;
            }

            clearTimeout(this.timer);
            this.timer = setTimeout(() => {

                //TODO: This needs to be changed to be on the COMPANY_ID not stock_id
                ApiService.writeContent({
                    stock_id: this.stockData.stock_id,
                    ticker: this.stockData.ticker,
                    user_id: JSON.parse(localStorage.user).user_id,
                    content: this.froalaContent,
                }).then(() => {
                    console.log("successfully froalaContent");
                });

                var temp = {
                    stock_id: this.stockData.stock_id,
                    isin: this.stockData.isin,
                    ticker: this.stockData.ticker,
                    user_id: JSON.parse(localStorage.user).user_id,
                    content: this.froalaContent,
                    last_update_date: new Date(),
                };
                this.$store.commit("addResearchs", temp);
            }, 1000);
        },
        $route (to, from) {
            this.flag = this.flag + 1
		},
        async stock_id() {
            // console.log('stock_id: ' + this.stock_id);

            this.reloadStockOverview = false;

            await this.loadPrices(this.stock_id);

            setTimeout(() => {
                this.reloadStockOverview = true;
            }, 200);
        }
    },
    created() {
        if(this.$route.query.tab === undefined) {
            this.data.tab = 0;
        }

        this.init();
        this.watchlist = this.$store.getters["getWatchlists"];
    },
    async mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const openResearchParam = urlParams.get('openResearch');

        // console.log(openResearchParam);

        if(openResearchParam === '1') {
            this.openDrawer();
        }

        this.reloadStockOverview = false;

        await this.loadPrices(this.stock_id);

        setTimeout(() => {
            this.reloadStockOverview = true;
        }, 500);

        this.toggleRight2 = this.paywallCriteria ? -48 : -43;
        this.topPositionResearch = this.paywallCriteria ? 20.87 : 20.37;

        this.$root.$on('changeToInvestorReports', (tab) => {
            this.tab = tab;
        });

        if (this.data.tab === 1) this.toggleEvent(true);
        this.tab = this.data && this.data.tab || 0;
        this.setBorderWidth();
        this.setEvents();
    },

    methods: {
        ...mapActions([
            'loadCompanyDataNeeded',
            'hasCompanyWebcast',
            'loadPrices'
        ]),
        ...mapMutations([
            'setMapStocks',
            'setRegisterType',
            'setRegisterWindows'
        ]),
        openDrawer() {
            this.dialog = true;
            this.option = 'research';
        },
        closeDrawer() {
            this.dialog = false;
        },
        saveNote() {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            this.saveStates = 'saved';
        },
        focusOnFroalaTextArea() {
            // console.log('focus textarea...');

            this.saveStates = 'saving';
        },
        blurOnFroalaTextArea() {
            // console.log('blur textarea...');

            this.saveStates = '';
        },
        focusNewNoteTextField() {
            setTimeout(() => {
                const element = this.$refs.myJournalElement.$refs.myTextarea.$el;

                element.focus();
            }, 300);
        },
        updateChart() {
            if (this.tab === 2) {
                this.$refs.chartPrice.updateChart();
            }
        },
        getTabInd(index) {
            this.$store.commit("setTab_overviewIndex", index);

            if (index === 2) {
                setTimeout(() => {
                    this.$refs.chartPrice.updateChart();
                }, 50);
            }
        },
        init() {
            if (this.data && this.data.company_id){
                ApiService.fetchInsiderData(this.data.company_id)
                    .then((response) => {
                        this.$store.commit("setInsiders", {
                            company_id: this.data.company_id,
                            insiders: response.data,
                        });
                        this.tab = this.data && this.data.tab || 0;
                    });
                ApiService.getOneCompanyAnalysis(this.data.company_id).then((data) => {
                    this.$store.commit("setOneCompanyAnalysts", data.data);
                });
                this.loadCompanyDataNeeded({company_id:this.data.company_id});
                this.hasCompanyWebcast({company_id:this.data.company_id});
            }

            var researchs = this.$store.getters.getResearchs;
            if (researchs.find(item => item.stock_id === this.stock_id)) {
                this.froalaContent = researchs.find(item => item.stock_id === this.stock_id).content;
            } else {
                this.froalaContent = this.default_froalaContent;
            }

        },
        setEvents() {
            if (!this.$refs.drawer) {
                return;
            }

            const el = this.$refs.drawer.$el;
            const drawerBorder = el.querySelector(".v-navigation-drawer__border");
            const vm = this;
            const direction = el.classList.contains("v-navigation-drawer--right")
                ? "right"
                : "left";

            function resize(e) {
                const maxWidth = vm.$refs.stocks.offsetWidth - 50;

                vm.estimatesRightContainerWidth = el.offsetWidth - 280;

                // console.log(vm.estimatesRightContainerWidth);

                document.getElementById('estimatesRightContainer').style.width = vm.estimatesRightContainerWidth + 'px';

                document.body.style.cursor = "ew-resize";
                let f = direction === "right"
                    ? document.body.scrollWidth - e.clientX
                    : e.clientX;

                if (f > maxWidth) {
                    f = maxWidth;
                }

                vm.toggleRight1 = f - 58;
                vm.toggleRight2 = vm.paywallCriteria ? f - 70 : f - 65;
                vm.navigation.width = f - 20 ;
            }

            function mouseUp() {
                vm.estimatesRightContainerWidth = el.offsetWidth - 265;

                // console.log(vm.estimatesRightContainerWidth);

                document.getElementById('estimatesRightContainer').style.width = vm.estimatesRightContainerWidth + 'px';
            }

            drawerBorder.addEventListener(
                "mousedown",
                function() {
                    el.style.transition ='initial';
                    document.addEventListener("mousemove", resize, false);
                    document.addEventListener("mousemove", mouseUp, false);
                },
                false
            );

            document.addEventListener(
                "mouseup",
                function() {
                    el.style.transition ='';
                    vm.navigation.width = el.style.width;
                    document.body.style.cursor = "";
                    document.removeEventListener("mousemove", resize, false);
                    document.removeEventListener("mousemove", mouseUp, false);
                },
                false
            );
        },

        setBorderWidth() {
            if (!this.$refs.drawer)
                return;
            let i = this.$refs.drawer.$el.querySelector(
                ".v-navigation-drawer__border"
            );
            i.style.width = this.navigation.borderSize + "px";
            i.style.cursor = "ew-resize";
        },

        childToggleEvent(data) {
            const key = data.key;
            const target = data.target;

            this.toggleEvent(key, target);
        },
        changeTab(tab) {
            this.option = tab;
        },
        toggleEvent(key=false,target='research') {
            if(target === 'estimate') {
                this.estimatesRightContainerWidth = 565;
                document.getElementById('estimatesRightContainer').style.width = this.estimatesRightContainerWidth + 'px';
            }

            if (key){
                this.target = 'research';
                this.navigation.shown = true;
            } else  {
                this.target = target;
                this.navigation.shown = true;
            }

            if (this.navigation.shown) {
                // console.log(this.$refs.stocks.offsetWidth);
                this.navigation.width = (this.$refs.stocks.offsetWidth <= 900) ? `${this.$refs.stocks.offsetWidth - 50}px` : '830px';
                this.toggleRight1 = this.navigation.width.replace("px" , "") -38;
                this.toggleRight2 = this.paywallCriteria ? this.navigation.width.replace("px" , "") -50 : this.navigation.width.replace("px" , "") -45;
            } else {
                this.toggleRight1 = -36.5;
                this.toggleRight2 = this.paywallCriteria ? -48 : -43;
            }
        },
        closeNavigation() {
            this.target = '';
            this.navigation.shown = false;
            this.navigation.width = `${this.$refs.stocks.offsetWidth/2 -120}px`;
            this.toggleRight1 = -36.5;
            this.toggleRight2 = this.paywallCriteria ? -48 : -43;
        },
        addToWatchlist() {
            this.is_show_tags_convictions = true;
        },
    }
};
</script>

<style scoped>

>>> .v-dialog {
    position: absolute;
    top: 48px;
    right: -20px;
}

[role="tablist"] .v-tabs-bar__content .stock-section {
    margin-left: 0 !important;
}

.stock-section.v-tab {
    color: #668099 !important;
}

.stocks-popup-btn {
    padding-left: 12px;
}

>>>.stocks-popup-btn .v-icon__component {
    height: 42px;
    width: 40px;
}

.stock-section.v-tab.v-tab--active {
    font-size: 0.9em;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 5px;
    color: #244360 !important;
}


>>> .fr-toolbar {
    background-color: #F5EDDA;
}

>>> .fr-toolbar,
>>> .fr-wrapper,
>>> .fr-second-toolbar {
    border: 0 !important;
}

>>> .fr-second-toolbar {
    border-radius: 0 0 5px 5px !important;
}

.fr-element.fr-view {
    padding-top: 10px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-bottom: 10px !important;
}

>>>#trading-vue-js .trading-vue-data-toolbar {
    -border: 1px solid red !important;
    height: auto;
    top: 0 !important;
    position: relative;
    z-index: 0 !important;
}

/*
This shouldn't be used to hide the toolbar in the chart, very
hard to track down if you don't know what you are looking for.
*/
/* >>>#trading-vue-js .trading-vue-toolbar {
    display: none;
} */

>>>#trading-vue-js .trading-vue-data-toolbar-container {
    -border: 1px solid;
    display: flex;
    justify-content: space-between;
}

/**/

.latest-top-company {}

.latest-top-srch {
    flex-grow: 1;
}

.latest-top-tags {
    display: flex;
}

.stock-section-header {
    align-content: center;
    border: 0px solid orange;
    display: flex;
    justify-content: space-between
}

.latest-company-title {
    align-items: center;
    display: flex
}

.latest-company-title .content-title {
    display: inline-block;
    line-height: 1.2;
    overflow: hidden;
    padding: 0 20px;
    text-overflow: ellipsis;
    width: 300px;
    white-space: nowrap
}



.latest-company-sector {
    padding-left: 80px
}

.latest-company-sector span {
    font-size: 18px;
    color: rgba(153, 153, 153, 1)
}

.latest-top-tags-container {
    border: 0px solid orange;
    border-radius: 8px;
    -width: 200px;
}

>>>.latest-top-tags-container > div:first-child {
    border: 1px solid orange !important;
    margin-bottom: 4px;
    padding: 0 !important;
    text-align: center
}

>>>.latest-top-tags-container div.latest-top-tags-selct {
    padding-left: 6px !important;
    border-radius: 8px;
    position: relative;
    cursor: pointer
}

>>>.latest-top-tags-selct > div > .v-chip {
    -background-color: transparent;
    color: #144b4d;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    height: 21px;
    margin: 5px 5px 5px 0 !important;
    padding: 2px 5px;
    text-transform: capitalize
}
>>>.theme--light.v-chip.v-chip--no-color {
    background-color: transparent !important;
}

>>>.latest-top-tags-selct > div > .v-chip .v-icon {
    margin: 0 2px 0 2px !important;
    max-height: 12px;
    max-width: 12px;
    opacity: .1;
}

>>>.latest-top-tags-selct > div > .v-chip:hover .v-icon {
    opacity: .5;
}

>>>.latest-top-tags-selct > div > .v-chip .v-icon:hover {
    opacity: 1;
}

>>>.latest-top-tags-selct > div > .v-chip:before {
    display: none;
}

.latest-top-tags-conv {
    -border: 1px solid rgba(20, 75, 77, .5);
    -border-radius: 8px;
    padding: 4px 0 0;
    text-align: center
}

>>>.latest-top-tags-conv button.v-icon {
    margin: 0 2px;
}

>>>.theme--light.v-tabs>.v-tabs-bar {
    background-color: transparent !important;
    height: 36px;
}

.v-tab.v-tab--active {
    background-color: #fff;
    border-radius: 6px 6px 0 0;
    font-weight: 600;
    text-decoration: none !important;
}

>>>.trading-vue-section,
>>>.trading-vue-js,
>>>.trading-vue-grid-0 {
    border: 0px solid;
    width: 100% !important;
}

>>>.trading-vue-section .trading-vue-sidebar-0 {
    left: auto !important;
    right: 0;
}

.v-tabs-items {
    padding: 18px;
}

/**/

.rotate-icon {
    animation: rotation 2s infinite linear;
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}
</style>
